<template>
  <div class="collage-total">
    <div class="middle-title">
      <img src="../../../../static/version1/标题箭头左.png" alt="">
      <span class="text">{{ title }}</span>
      <img src="../../../../static/version1/标题箭头右.png" alt="">
    </div>
    <div class="totalBar-content">
      <swiper ref="mySwiper" :options="swiperOptions" @mouseenter="stopAutoplayAnimation" @mouseleave="reStartAnimation"
        v-if="patentList.length > 0">
        <swiper-slide v-for="(item, index) in patentList" :key="index">
          <div class="item" @click="detailClick(item)">
            <div class="content-number">
              <img src="../../../../static/version2/学院专利总数图标3.png" alt="" v-if="index % 2 === 0">
              <img src="../../../../static/version2/学院专利总数图标4.png" alt="" v-else>
              <span class="name">{{ item.name }}</span>
            </div>
            <div class="progress-block">
              <div class="progress">
                <img src="../../../../static/version2/矩形1.png" class="bck" alt="" v-if="index % 2 === 0"
                  :style="{ 'width': item.ratio + '%' }">
                <img src="../../../../static/version2/矩形1拷贝3.png" class="bck" alt="" v-else
                  :style="{ 'width': item.ratio + '%' }">
                <img src="../../../../static/version2/学院专利总数图标.png" class="huan" alt="" v-if="index % 2 === 0">
                <img src="../../../../static/version2/学院专利总数图标2.png" class="huan" alt="" v-else>
              </div>
              <span class="count">{{ item.count }}</span>
            </div>

          </div>
        </swiper-slide>
      </swiper>
      <img src="../../../../static/nodata3.png" alt="" v-else class="no-data">
    </div>
  </div>
</template>

<script>
import { getPatentAll, ipcsecRange, seiRange } from '@/api/databaseBin'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import BaseMixin from '@/views/_mixin'
import { getStorage } from '@/utils'
import { mapState } from 'vuex'

export default {
  mixins: [BaseMixin],
  created() {
    this.initData()
  },
  data() {
    return {
      patentList: [],
      swiperOptions: {
        init: false,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false // 触碰后自动轮播也不会停止
        },
        height: 260,
        spaceBetween: 5, // 板块间隔
        slidesPerView: 5, // 页面中的板块数量
        direction: 'vertical',
        observer: true,
        observeParents: true,
        loop: false // 首尾循环
      }
    }
  },
  methods: {
    detailClick(item) {
      // this.gov = true,字段叫 ipc_section_stat 否则 org_name_stat
      if (this.isGov) {
        if (this.useNewGovTemplate) {
          this.jumpIpi(`战略性新兴产业分类=(${item.classCode}) and 专利类型=(发明授权 or 实用新型 or 外观设计)`)
        } else {
          this.jumpIpi('ipc_section_stat=' + item.classCode)
        }
      } else {
        this.jumpIpi('org_name_stat=' + item.name)
      }
    },
    style(v) {
      console.log(v)
      return { left: v - 6 + '%' }
    },
    async initData() {
      let result = null
      if (this.isGov) {
        const govRange = this.useNewGovTemplate ? seiRange : ipcsecRange
        result = await govRange()
        if (result.code === 200) {
          result.data.forEach(item => {
            item.name = item.classCode + ' ' + item.classCnName
          })
        }
      } else {
        result = await getPatentAll()
      }
      this.patentList = result[this.dataMapping]
      const data = this.patentList.sort(function (a, b) {
        return b.count - a.count
      })
      const maxcount = data[0].count
      this.patentList.forEach((element) => {
        element.ratio = (element.count / maxcount).toFixed(2) * 100
      })
      this.$forceUpdate()
      this.$nextTick(() => {
        this.swiper.init()
      })
    },
    stopAutoplayAnimation() {
      this.swiper.autoplay.stop()
    },
    reStartAnimation() {
      this.swiper.autoplay.start()
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    ...mapState('title', ['title']),
    ...mapState('user', ['useNewGovTemplate']),
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    isGov() {
      return getStorage('tenantType', 0) === 'government'
    }
  }
}
</script>
